import api from '@/utils/api'
import {Commit} from 'vuex'


const actions = {
  async api_compliance_audit_application_record_list(_context: { commit: Commit }, params: any) {
    return api.post('/api/complianceAudit/list_apply', params)
  },
  async api_compliance_audit_application_record_delete(_context: { commit: Commit}, params: any) {
    return api.post('/api/complianceAudit/delete_apply', params);
  },
}

export default {
  actions
}
